import { forum_api_feed_url } from 'mk/urls/functions';
import { forumHeaderUpdate, forumUpdateComplaintsStatistics, LastVisitCounts } from 'mk2/apps/forum/actions';
import {
    FORUM_FEED_LOAD,
    forumFeedFetch,
    ForumFeedFetchNormalizedResponse,
    ForumFeedFetchRequestAction,
} from 'mk2/apps/forum/containers/ForumFeed/ForumFeed.actions';
import {
    BrandDaysCampaignEntity,
    BrandDaysCampaignSchema,
    ComplaintsStatisticsPerPost,
    PostEntity,
    PostSchema,
} from 'mk2/apps/forum/schemas';
import { normalizeError, XHRAction } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('forum/ForumFeed.sagas');

interface ApiResponsePosts {
    body: {
        posts: PostEntity[];
        hasNext: number;
        hasPrevious: number;
        lastVisitCounts: LastVisitCounts;
        notificationsOn: number[];
        complaintsStatistics: ComplaintsStatisticsPerPost;
        showHint: boolean;
        brandDays: { posts: PostEntity[]; campaign: BrandDaysCampaignEntity; }
    };
}

function* fetchForumFeed({ after, orderBy, xhr }: ForumFeedFetchRequestAction & XHRAction) {
    yield put(forumFeedFetch.request(orderBy, after));

    try {
        const response: ApiResponsePosts = yield call(
            () => xhr.get(forum_api_feed_url(), { after, orderby: orderBy }),
        );

        const normalizedResponse: ForumFeedFetchNormalizedResponse = normalize(response.body, {
            posts: [PostSchema],
            brandDays: { posts: [PostSchema], campaign: BrandDaysCampaignSchema },
        });

        yield put(forumUpdateComplaintsStatistics(response.body.complaintsStatistics));
        yield put(forumFeedFetch.success(
            orderBy,
            after,
            response.body.hasNext,
            response.body.hasPrevious,
            response.body.notificationsOn,
            response.body.showHint,
            normalizedResponse,
        ));
        yield put(forumHeaderUpdate(response.body.lastVisitCounts));

    } catch (error) {
        logger.error(error);

        yield put(forumFeedFetch.failure(orderBy, after, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(FORUM_FEED_LOAD, fetchForumFeed),
    ]);
}
